import { render, staticRenderFns } from "./DeliveryNoteNew.vue?vue&type=template&id=24e1e194&scoped=true"
import script from "./DeliveryNoteNew.vue?vue&type=script&lang=js"
export * from "./DeliveryNoteNew.vue?vue&type=script&lang=js"
import style0 from "./DeliveryNoteNew.vue?vue&type=style&index=0&id=24e1e194&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e1e194",
  null
  
)

export default component.exports